<template>
  <div class="col-md-12">
    <div v-if="currentUser" class="card card-container">
      <h4><font-awesome-icon icon="edit" /> Edit User Details</h4>
      <form name="form" @submit.prevent="updateUser">
        <div v-if="!successful">
          <input v-model="currentUser.password" type="hidden" id="password" name="password">
          <div class="form-group">
            <label for="staffNo">Staff No.:</label>
            <input v-model="currentUser.staffNo" v-validate="'required|max:75'" type="text" class="form-control" id="staffNo" name="staffNo"/>
            <div v-if="submitted && errors.has('staffNo')" class="alert-danger">{{errors.first('staffNo')}}</div>
          </div>
          <div class="form-group">
            <label for="firstName">First Name:</label>
            <input v-model="currentUser.firstName" v-validate="'required|max:75'" type="text" class="form-control" id="firstName" name="firstName"/>
            <div v-if="submitted && errors.has('firstName')" class="alert-danger" >{{errors.first('firstName')}}</div>
          </div>
          <div class="form-group">
            <label for="lastName">Last Name:</label>
            <input v-model="currentUser.lastName" v-validate="'required|max:75'" type="text" class="form-control" id="lastName" name="lastName"/>
            <div v-if="submitted && errors.has('lastName')" class="alert-danger" >{{errors.first('lastName')}}</div>
          </div>
          <div class="form-group">
            <label for="username">Username:</label>
            <input v-model="currentUser.username" v-validate="'required|min:3|max:20'" type="text" class="form-control" id="username" name="username"/>
            <div v-if="submitted && errors.has('username')" class="alert-danger">{{errors.first('username')}}</div>
          </div>
          <div class="form-group">
            <label for="email">Email:</label>
            <input v-model="currentUser.email" v-validate="'required|email|max:50'" type="email" class="form-control" id="email" name="email"/>
            <div v-if="submitted && errors.has('email')" class="alert-danger">{{errors.first('email')}}</div>
          </div>
          <div class="form-group">
            <label><strong>Status: </strong>{{ currentUser.active ? "Active" : "Inactive" }}</label>
          </div>
          <div class="form-group">
            <label for="types">User Type: </label>
            <select v-model="currentUserTypeCode" v-validate="'required|min:3|max:30'" class="form-control" id="userType" name="userType">
              <option v-for="type in types" v-bind:value="type.code" :key="type.code">{{ type.name }}</option>
            </select>
            <div v-if="submitted && errors.has('types')" class="alert-danger">{{errors.first('types')}}</div>
          </div>
          
          <div class="form-group">
            <button class="badge badge-warning mr-2" v-if="currentUser.active" @click="updateActive(false)"><font-awesome-icon icon="minus-square" /> DeActivate</button>
            <button v-else class="badge badge-warning mr-2" @click="updateActive(true)"><font-awesome-icon icon="plus-square" /> Activate</button>
            <button class="badge badge-danger mr-2" @click="deleteUser"><font-awesome-icon icon="trash-alt" /> Delete</button>
            <button type="submit" class="badge badge-success mr-2"><font-awesome-icon icon="save" /> Update</button>
            <button class="badge badge-primary" @click="usersList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      <div v-if="message && successful">
        <button class="btn btn-primary" @click="usersList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
      </div>
    </div>
    <div v-else>
      <br />
      <p>Please click on a User...</p>
    </div>
  </div>
</template>

<script>
import UserService from "../services/user.service";

export default {
  name: 'user',
  data() {
    return {
      currentUser: null,
      submitted: false,
      successful: false,
      message: '',
      currentUserTypeCode: '',
      currentUserTypeName: '',
      types: [
         { code: 'mem', name: 'Member' },
         { code: 'entry', name: 'Data Entry' },
         { code: 'man', name: 'Manager' },
         { code: 'aud', name: 'Auditor' },
         { code: 'admin', name: 'Admin' },
         { code: 'super', name: 'Super Admin' }
      ],
      typeSet: new Set(),
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    getUser(id) {
      UserService.get(id)
        .then(response => {
          this.currentUser = response.data;
          console.log(response.data);
          for(let userRole of this.currentUser.roles) {
            console.log(userRole.name);
            if(userRole.name=='ROLE_USER'){
              //this.currentUserType.push({ code: 'mem', name: 'Member' });
              this.currentUserTypeCode = 'mem';
              this.currentUserTypeName = 'Member';
              break;
            }
            if(userRole.name=='ROLE_DATAENTRY'){
              //this.currentUserType.push({ code: 'entry', name: 'Data Entry' });
              this.currentUserTypeCode = 'entry';
              this.currentUserTypeName = 'Data Entry';
              break;
            }
            if(userRole.name=='ROLE_MANAGER'){
              //this.currentUserType.push({ code: 'man', name: 'Manager' });
              this.currentUserTypeCode = 'man';
              this.currentUserTypeName = 'Manager';
              break;
            }
            if(userRole.name=='ROLE_AUDITOR'){
              //this.currentUserType.push({ code: 'aud', name: 'Auditor' });
              this.currentUserTypeCode = 'aud';
              this.currentUserTypeName = 'Auditor';
              break;
            }
            if(userRole.name=='ROLE_ADMIN'){
              //this.currentUserType.push({ code: 'admin', name: 'Admin' });
              this.currentUserTypeCode = 'admin';
              this.currentUserTypeName = 'Admin';
              break;
            }
            if(userRole.name=='ROLE_SUPERADMIN'){
              //this.currentUserType.push({ code: 'super', name: 'Super Admin' });
              this.currentUserTypeCode = 'super';
              this.currentUserTypeName = 'Super Admin';
              break;
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    updateActive(status) {
      var userData = {
        id: this.currentUser.id,
        staffNo: this.currentUser.staffNo,
        firstName: this.currentUser.firstName,
        lastName: this.currentUser.lastName,
        username: this.currentUser.username,
        email: this.currentUser.email,
        active: status,
        userType: this.currentUserTypeCode
      };

      UserService.update(this.currentUser.id, userData)
        .then(response => {
          this.currentUser.active = status;
          console.log(response.data);
        },
        error => {
          this.message = (error.response && error.response.data) || error.message || error.toString();
          this.successful = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    updateUser() {
      this.message = '';
      this.submitted = true;
      this.currentUser.userType = this.currentUserTypeCode;
      this.$validator.validate().then(isValid => {
        if (isValid) {
          UserService.update(this.currentUser.id, this.currentUser).then(
            response => {
              console.log(response.data);
              this.message = 'The user was updated successfully!';
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log(e);
            });
        }
      });
    },

    deleteUser() {
      UserService.delete(this.currentUser.id)
        .then(response => {
          console.log(response.data);
          this.$router.push({ name: "users" });
        })
        .catch(e => {
          console.log(e);
        });
    },

    usersList() {
      this.$router.push('/users');
    }
  },
  mounted() {
    this.message = '';
    this.getUser(this.$route.params.id);
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>